import React from 'react';
import styled from 'styled-components';

import { getBucketVariantColors } from '@/features/csvImport/admin/constants/bucketVariants';
import { CsvImportBucketVariant } from '@/features/csvImport/admin/types/csvImport';

const DOT_SIZE = 6;

/**
 * A static, non-interactive badge. `@/ui/Chip` covers the interactive chips (filter,
 * input, dropdown) and carries selection and hover behaviour this label must not have.
 */
const RootStyled = styled.span<{ $variant: CsvImportBucketVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${(p) => getBucketVariantColors(p.theme, p.$variant).surface};
`;

const DotStyled = styled.span<{ $variant: CsvImportBucketVariant }>`
  flex-shrink: 0;
  width: ${DOT_SIZE}px;
  height: ${DOT_SIZE}px;
  border-radius: 3px;
  background-color: ${(p) => getBucketVariantColors(p.theme, p.$variant).accent};
`;

const LabelStyled = styled.span<{ $variant: CsvImportBucketVariant }>`
  ${(p) => p.theme.typography.caption};
  font-weight: 600;
  white-space: nowrap;
  color: ${(p) => getBucketVariantColors(p.theme, p.$variant).label};
`;

type CsvImportBucketChipProps = {
  label: string;
  count: number;
  variant?: CsvImportBucketVariant;
  className?: string;
};

export const CsvImportBucketChip = ({ label, count, variant = 'neutral', className }: CsvImportBucketChipProps): JSX.Element => (
  <RootStyled className={className} $variant={variant}>
    <DotStyled $variant={variant} aria-hidden />
    <LabelStyled $variant={variant}>{`${label} (${count})`}</LabelStyled>
  </RootStyled>
);
